import { render, staticRenderFns } from "./lang-switcher.vue?vue&type=template&id=0048679d&scoped=true&"
import script from "./lang-switcher.vue?vue&type=script&lang=js&"
export * from "./lang-switcher.vue?vue&type=script&lang=js&"
import style0 from "./lang-switcher.vue?vue&type=style&index=0&id=0048679d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0048679d",
  null
  
)

export default component.exports